module.exports = __webpack_public_path__ + "static/img/u67.fb8a3d17.png";